import axios from "@utils/axiosExt";
import config from "./../config/config";
const validateMapLocation = async (lattitude: string, longitude:string) => {
        const res = await axios.get(`${config.googleMapApiUrl}?latlng=${parseFloat(lattitude)},${parseFloat(longitude)}&key=${config.googleMapToken}`);
            if(res.data && res.data.status === 'OK') {
              const response = res.data.results && res.data.results[0];
              const { address_components, formatted_address} = response;
              let pincode = '';
              address_components.forEach((li:any) => {
                if(li.types.includes("postal_code")) {
                  pincode = li.long_name
                }
              });
            return {
                pincode: pincode,
                address: formatted_address
            }
        } else {
            return;
        }
}
export default validateMapLocation;